import { createSelector } from '@ngrx/store';
import { authFeatures } from '../reducers/auth-features';

export const { selectAuthBusinessProfilesPage: selectAuthBusinessProfilesPageState } = authFeatures;
export const selectError = createSelector(selectAuthBusinessProfilesPageState, (state) => state.error);
export const selectPending = createSelector(selectAuthBusinessProfilesPageState, (state) => state.pending);
